export const ERRORS = 'errors';
export const CONTRACT_ID_ERROR = 'contractId';
